import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Members, membersMission, MembersPagination, Mission, MissionPagination } from './missions.types';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MissionsService {
  private baseUrl: string;
  private _missions: BehaviorSubject<Mission[] | null> = new BehaviorSubject(null);
  private _pagination: BehaviorSubject<MissionPagination | null> = new BehaviorSubject(null);
  private _missionsGroup: BehaviorSubject<Mission[] | null> = new BehaviorSubject(null);
  private _paginationGroup: BehaviorSubject<MissionPagination | null> = new BehaviorSubject(null);
  private _missionMembers: BehaviorSubject<Members[] | null> = new BehaviorSubject(null);
  private _paginationMembers: BehaviorSubject<MembersPagination | null> = new BehaviorSubject(null);

  private _rankings: BehaviorSubject<any[] | null> = new BehaviorSubject(null);
  private _pagination_rankings: BehaviorSubject<any | null> = new BehaviorSubject(null);

  private _rankingsgroup: BehaviorSubject<any[] | null> = new BehaviorSubject(null);
  private _pagination_rankingsgroup: BehaviorSubject<any | null> = new BehaviorSubject(null);

  private _missionsUsers: BehaviorSubject<membersMission | null> = new BehaviorSubject(null);
  constructor(private httpClient: HttpClient) {
    this.baseUrl = `${environment.apiURL}/missions-managment`;
  }

  get mission$(): Observable<Mission[]> {
    return this._missions.asObservable();
  }


  get pagination$(): Observable<MissionPagination> {
    return this._pagination.asObservable();
  }

  get missionGroup$(): Observable<Mission[]> {
    return this._missionsGroup.asObservable();
  }


  get paginationGroup$(): Observable<MissionPagination> {
    return this._paginationGroup.asObservable();
  }

  get missionMembers$(): Observable<Members[]> {
    return this._missionMembers.asObservable();
  }


  get paginationMembers$(): Observable<MembersPagination> {
    return this._paginationMembers.asObservable();
  }

  get membersMission$(): Observable<membersMission>{
    return this._missionsUsers.asObservable();
  }
  banner(id) {

    const endpoint: string = this.baseUrl + '/banner/group/' + id;
    return this.httpClient.get(endpoint);
  }

  list(userId: number, page: number = 0, size: number = 1000, sort: string = 'id', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<MissionPagination> {
    const endpoint: string = this.baseUrl + '/individual/missions';

    return this.httpClient.get<MissionPagination>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search,
        customer_id: userId
      }
    }).pipe(tap((res) => {

      const products = res.data.map(item => {

        return item;
      });

      res.data = products;
      this._missions.next(res.data);
      this._pagination.next(res);

    }));
  }

  listGroup(userId: number, page: number = 0, size: number = 1000, sort: string = 'id', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<MissionPagination> {
    const endpoint: string = this.baseUrl + '/group/missions';

    return this.httpClient.get<MissionPagination>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search,
        customer_id: userId
      }
    }).pipe(tap((res) => {

      const products = res.data.map(item => {

        return item;
      });

      res.data = products;
      this._missionsGroup.next(res.data);
      this._paginationGroup.next(res);

    }));
  }

  listMembers(group_id: number, page: number = 0, size: number = 5, sort: string = 'name', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<MembersPagination> {
    const endpoint: string = this.baseUrl + '/group/members';

    return this.httpClient.get<MembersPagination>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search,
        group_id: group_id
      }
    }).pipe(tap((res) => {

      const products = res.data.map(item => {

        return item;
      });

      res.data = products;
      this._missionMembers.next(res.data);
      this._paginationMembers.next(res);

    }));
  }

  listranking(missionid: number, page: number = 0, size: number = 8, sort: string = 'id', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<any> {
    const endpoint: string = `${environment.apiURL}/users` + '/winners-managment/ranking';

    return this.httpClient.get<any>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search,
        mission_id: missionid
      }
    }).pipe(tap((res) => {

      const products = res.data.map(item => {

        return item;
      });

      res.data = products;
      this._rankings.next(res.data);
      this._pagination_rankings.next(res);

    }));
  }

  listrankinggroup(missionid: number, page: number = 0, size: number = 8, sort: string = 'compliance', order: 'asc' | 'desc' | '' = 'desc', search: string = ''):
    Observable<any> {
    const endpoint: string = `${environment.apiURL}/groups` + '/winners-managment/ranking';

    return this.httpClient.get<any>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search,
        mission_id: missionid
      }
    }).pipe(tap((res) => {

      const products = res.data.map(item => {

        return item;
      });

      res.data = products;
      this._rankingsgroup.next(res.data);
      this._pagination_rankingsgroup.next(res);

    }));
  }

  verParticipantes(mission_id:number,comparation_id:number):
    Observable<membersMission> {
    const endpoint: string = `${environment.apiURL}`+'/missions/missionDetail';

    return this.httpClient.get<membersMission>(endpoint, {
      params:{
        comparation_id,
        mission_id
      }
    }).pipe(tap((res) => {
      if(res){
        this._missionsUsers.next(res);
      }
    }));
  }
  
  individualclaim(data: any) {
    const endpoint: string = this.baseUrl + '/individual/reward';
    return this.httpClient.post(endpoint, data);
  }

  groupclaim(data: any) {
    const endpoint: string = this.baseUrl + '/group/reward';
    return this.httpClient.post(endpoint, data);
  }

}
